import { Dispatch } from 'redux';
import { GetFltopsDelays } from '../../services/DelayListService/DelayListService';
import { DelayCollectionModel, DelayListCollection } from '../../Model/DelayListCollection';

// Action Types
export const FETCH_FLTOPS_DELAYS_REQUEST = 'FETCH_FLTOPS_DELAYS_REQUEST';
export const FETCH_FLTOPS_DELAYS_SUCCESS = 'FETCH_FLTOPS_DELAYS_SUCCESS';
export const FETCH_FLTOPS_DELAYS_FAILURE = 'FETCH_FLTOPS_DELAYS_FAILURE';

// Action Creator
export const fetchFltopsDelays = (token: string, station: string, delayCode: string, flightDate: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: FETCH_FLTOPS_DELAYS_REQUEST });
    
    try {
      const fltopslist = await GetFltopsDelays(token, station, delayCode, flightDate);
      dispatch({
        type: FETCH_FLTOPS_DELAYS_SUCCESS,
        payload: fltopslist
      });
    } catch (error:any) {
      dispatch({
        type: FETCH_FLTOPS_DELAYS_FAILURE,
        payload: error.message
      });
    }
  };
};
